var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___bDRNLU",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___bDRNLU",
  "Se": "ChannelAttachmentArea.module__upload___bDRNLU",
  "PO": "ChannelAttachmentArea.module__uploadContainer___bDRNLU",
  "il": "ChannelAttachmentArea.module__mediaContainer___bDRNLU",
  "BA": "ChannelAttachmentArea.module__clickableMedia___bDRNLU",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___bDRNLU",
  "R": "ChannelAttachmentArea.module__hidden___bDRNLU",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___bDRNLU",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___bDRNLU",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___bDRNLU",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___bDRNLU",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___bDRNLU",
  "p6": "ChannelAttachmentArea.module__spoiler___bDRNLU",
  "$_": "ChannelAttachmentArea.module__media___bDRNLU",
  "_A": "ChannelAttachmentArea.module__tags___bDRNLU",
  "H6": "ChannelAttachmentArea.module__filenameContainer___bDRNLU",
  "iW": "ChannelAttachmentArea.module__filename___bDRNLU",
  "VF": "ChannelAttachmentArea.module__fileDetails___bDRNLU",
  "Ov": "ChannelAttachmentArea.module__fileSize___bDRNLU",
  "i_": "ChannelAttachmentArea.module__fileExtension___bDRNLU",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___bDRNLU",
  "KY": "ChannelAttachmentArea.module__actionBar___bDRNLU" + " " + __webpack_require__(180357)["KE"],
  "x6": "ChannelAttachmentArea.module__button___bDRNLU" + " " + __webpack_require__(180357)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___bDRNLU",
  "le": "ChannelAttachmentArea.module__actionBarIcon___bDRNLU",
  "s3": "ChannelAttachmentArea.module__altTag___bDRNLU",
  "Kk": "ChannelAttachmentArea.module__icon___bDRNLU",
  "Dp": "ChannelAttachmentArea.module__iconImage___bDRNLU",
  "t0": "ChannelAttachmentArea.module__spin___bDRNLU",
  "vt": "ChannelAttachmentArea.module__videoModal___bDRNLU",
  "j": "ChannelAttachmentArea.module__videoContainer___bDRNLU",
  "yF": "ChannelAttachmentArea.module__divider___bDRNLU",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___bDRNLU",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___bDRNLU",
};

module.exports = exports;
